// Prepared layouts follow immutable network snapshots. Combining regions
// keeps their layouts instead of walking every retained city's routes again.
import * as Core from '@tol/core/core';
import type { LineId, LineLayout, Network } from '@tol/core/types';
import { cooperate } from '@tol/core/work';

export const preparedLayouts = new WeakMap<Network, ReadonlyMap<LineId, LineLayout>>();

export async function prepareNetworkLayouts(net: Network, signal?: AbortSignal): Promise<void> {
  function* prepare(): Generator<void, Map<LineId, LineLayout>, void> {
    const layouts = new Map<LineId, LineLayout>();
    for (const line of Object.values(net.lines)) {
      if (line) layouts.set(line.id, Core.linePaths(net, line.id, true));
      yield;
    }
    return layouts;
  }
  preparedLayouts.set(net, await cooperate(prepare(), signal));
}
